var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatDiversion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cat_diversion",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_15",
    "data-name": "Rect\\xE1ngulo 15",
    width: 200,
    height: 200,
    fill: "#e8eff1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-party-21",
    d: "M106.876,142.258h-.107a2.963,2.963,0,0,1-2.958-2.863c-.3-8.666,1.126-16.875,13.426-18.257,4.712-.528,5.086-2.175,5.9-5.791,1.357-5.975,3.6-11.393,16.01-12.045a2.91,2.91,0,0,1,3.118,2.8,2.964,2.964,0,0,1-2.8,3.118c-8.962.468-9.591,3.242-10.539,7.433-.9,3.954-2.128,9.371-11.031,10.379-6.022.67-8.488,2.507-8.162,12.157a2.965,2.965,0,0,1-2.857,3.064ZM57.429,31.332a11.907,11.907,0,0,0,4.991,2.632l21.137,5.311a8.426,8.426,0,0,0,5.353-.415c6.414-2.733,22.892-9.982,30-12.774a3.8,3.8,0,0,1,3.883,6.5c-8.239,6.295-33.87,24.22-33.87,24.22L83.818,78.431s10.581,11.025,15.08,16c2.507,2.78,4.126,5.447,2.5,9.454-2.851,7-8.636,20.61-11.31,26.952-1.512,3.586-6.9,2.685-6.016-1.909,1.286-6.686,4.629-23.8,4.629-23.8l-21.09-9.6s-1.5,35.286-1.938,43.247a3.445,3.445,0,0,1-3.45,3.485c-1.476-.006-3.011-1.025-3.628-3.533-3.165-12.91-12.7-53.288-12.7-53.288-1.239-4.961-1.95-9.069-.314-15.2L51,47.419S34.845,23.8,29.018,14.96c-2.383-3.622,2.11-6.994,4.789-4.623l23.621,21ZM14.881,81.65,9.825,84.679l16.052,26.816c-10.6,1.814-17.291,11.286-12.14,19.893,3.183,5.317,10.391,6.556,15.542,3.474,6.129-3.669,10.515-11.57,5.8-19.466ZM119.922,50.869l5.358,9.893L136.347,62.8l-7.753,8.156,1.476,11.155-10.148-4.855-10.154,4.855,1.482-11.155L103.491,62.8l11.067-2.039ZM17.388,33.472,0,50.869l17.391,17.4,17.4-17.4-17.4-17.4Zm53.674-32A16.077,16.077,0,1,1,63.172,22.8,16.076,16.076,0,0,1,71.062,1.475Z",
    transform: "translate(28.867 28.861)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatDiversion);
export default __webpack_public_path__ + "static/media/cat_diversion.23473adbcfc0efa5e97c5a1d2be58c19.svg";
export { ForwardRef as ReactComponent };